const protocolPattern = /^https?:\/\//;
const searchStringPattern = /\?.*/;

export function niceURL(url) {
	return (url || '').replace(protocolPattern, '').replace(searchStringPattern, '');
}